<template>
  <div>
    <red-characters-header
      :title="page.template.header"
      :content="page.template.tekst"
    />

    <main v-if="page.template.tekst_2" class="content container">
      <circle-img-content
        circle-txt
        :circle-content="page.template.header_2"
        :image-url="page.active_image ? page.active_image.url : ''"
        class="z-50 mt-0 lg:mt-40"
      >
        <div class="content prose" v-html="page.template.tekst_2"/>
      </circle-img-content>
    </main>

    <wave-content v-if="page.template.tekst_3" text-only class="content" :header-text="page.template.header_3">
      <div class="content prose" v-html="page.template.tekst_3"/>
    </wave-content>
  </div>
</template>

<script>
import RedCharactersHeader from '~/components/headers/RedCharactersHeader';
import CircleImgContent from '~/components/fullwidth-blocks/CircleImgContent';
import WaveContent from '~/components/fullwidth-blocks/WaveContent';

export default {
  components: {WaveContent, CircleImgContent, RedCharactersHeader},
  props: {
    page: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>
